var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nadlan-menu"},[_c('nav',{staticClass:"container-fluid"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:_vm.isActive(tab.page)},[_c('router-link',{attrs:{"to":_vm.mixin_computeTargetPath()[tab.key]}},[_vm._v(" "+_vm._s(tab.label)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }